import React from "react";
import ReactLoading from 'react-loading'

const Loading = ({size = -1, color="#34AED4"}) => {
    return <div style={{display: 'flex', height: '100svh', alignItems: 'center', justifyContent: 'center', width:'100%'}}>
        <ReactLoading color={color} type="spinningBubbles" height={size === -1?undefined: size} width={size === -1?undefined: size} ></ReactLoading>
        </div>
}

export default Loading